'use client';

import Link from 'next/link';
import { useMemo } from 'react';
import Button from '~/components/customComponents/buttons/Button';
import Flex from '~/components/customComponents/flex/Flex';
import Text from '~/components/customComponents/texts/Text';
import { useI18n } from '~/locales/client';

const RetryResetPassword = ({
  email,
  isSendButtonLoading,
  redirectToForm,
  onButtonClick,
}: {
  email: string;
  isSendButtonLoading: boolean;
  redirectToForm: () => void;
  onButtonClick: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
}) => {
  const translate = useI18n();

  const copy = useMemo(
    () => ({
      verifyTitleLabel: translate('page.forgot-password.view.verify.title'),
      verifyDescriptionLabel: translate('page.forgot-password.view.verify.description', {
        email: <b>{email}</b>,
      }),
      verifyDescriptionSupportLabel: translate(
        'page.forgot-password.view.verify.description.support',
      ),
      resendButtonLabel: translate('page.forgot-password.view.verify.resend.button'),
      changeEmailLabel: translate('page.forgot-password.view.button.retry.change'),
    }),
    [translate, email],
  );

  return (
    <>
      <Flex className="flex-col mb-8">
        <Flex className="flex-col">
          <Text variant="h1">{copy.verifyTitleLabel}</Text>
          <Text color="gray" className="mb-10 mt-2.5">
            {copy.verifyDescriptionLabel}
          </Text>

          <Text color="gray" className="mt-2.5 ">
            {copy.verifyDescriptionSupportLabel}
          </Text>
        </Flex>
      </Flex>
      <Button
        onClick={onButtonClick}
        isLoading={isSendButtonLoading}
        text={copy.resendButtonLabel}
        buttonClassName="hover:bg-red-700"
      />
      <Flex className="mt-5 justify-center">
        <Link href="#" onClick={redirectToForm} className="text-base hover:underline">
          {copy.changeEmailLabel}
        </Link>
      </Flex>
    </>
  );
};

export default RetryResetPassword;
